import Api from "./api";

const checkStatus = () => {
    return Api().get('/status')
        .then(response => {
            return response
        })
}

const fetchWallboardConfig = () => {
    return Api().get('/wallboard-config')
        .then(response => {
            return response
        })
}

export {checkStatus, fetchWallboardConfig}